import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../logo.png';
import { useAuth } from '../context/AuthContext';
import './NavBar.css';

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logo}
          alt="Logo"
          className="navbar-logo"
          onClick={() => handleNavigate('/')}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              handleNavigate('/');
            }
          }}
        />
      </div>
      <div className="navbar-right">
        <div className="profile-menu" ref={menuRef}>
          <button className="profile-icon" onClick={toggleMenu} aria-label="Profile menu">
            &#9776;
          </button>
          {menuOpen && (
            <ul className="menu-dropdown">
              <li><button onClick={() => handleNavigate('/')}>Home</button></li>
              <li><button onClick={() => handleNavigate('/dashboard')}>Dashboard</button></li>
              <li><button onClick={() => handleNavigate('/training-history')}>History</button></li>
              <li><button onClick={() => handleNavigate('/profile')}>Profile</button></li>
              <li><button onClick={() => handleNavigate('/settings')}>Settings</button></li>
              <li><button onClick={() => handleNavigate('/support')}>Support</button></li>
              <li><button onClick={handleLogout}>Logout</button></li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
